export const strings = {
  auth: {
    header: {
      signOut: "Sign out",
    },
    signedOut: {
      unreachedTitle: "You're signed out of Link",
      unreachedBody:
        "Optymyse couldn't be reached to sign you out everywhere, so its other apps may still be signed in. Sign out of one of them, or sign in here and try again.",
      signInAgain: "Sign in again",
    },
    regionUnavailable: {
      title: "Link isn't available in your region yet",
      body: "Your Optymyse account is in a region where Link isn't available yet. Link has not signed you in, and has kept nothing about you.",
      back: "Back to Link",
    },
  },
  workspaces: {
    none: {
      title: "No Link workspace yet",
      body: "A Link workspace belongs to an organisation at Optymyse. Ask one of its owners or admins to give you Link. Once you have accepted the invitation from your email, sign in again.",
      signInAgain: "Sign in again",
      wrongAccount: "Not the right Optymyse account?",
    },
    switcher: {
      title: "Choose a workspace",
      lead: "You can use Link in more than one workspace.",
      list: "Your workspaces",
      unchecked:
        "Optymyse couldn't be asked about some of your workspaces just now, so they aren't listed. Try again shortly.",
      notYou: "Not you?",
    },
    settings: {
      title: "General",
      nameLabel: "Workspace name",
      slugLabel: "Address",
      regionLabel: "Data location",
      regions: { eu: "European Union", us: "United States" },
      managedAtOptymyse:
        "This workspace is your organisation's at Optymyse. Its name and address, who owns and administers it, and closing it are managed there.",
    },
    /** A role in Link, in the People page's words (SuiteUi's: an Administrator is its Admin). */
    roles: { administrator: "Admin", editor: "Editor", viewer: "Viewer" },
    people: {
      description:
        "{name}'s owners and admins choose who has Link and who is its Admin. Link's Administrators make people Editors; everyone else is a Viewer.",
      editor: "Can add and change customers and contacts.",
      viewer: "Can look up customers and contacts, and change nothing.",
    },
    access: {
      denied: {
        title: "No access to this workspace",
        body: "Your Optymyse account does not currently have access to this workspace in Link. Ask a workspace owner or admin to give you access.",
      },
      unavailable: {
        title: "Workspace access can't be checked",
        body: "Link cannot verify your access with Optymyse right now. Please try again shortly.",
      },
      toWorkspaces: "Your workspaces",
    },
  },
  directory: {
    unavailable: "Your organisation's directory can't be reached right now. Please try again shortly.",
    retry: "Try again",
    capped: "Showing the {cap} most recently changed. Older ones aren't in this list yet, so search may miss them.",
    viewerNote: "You're a Viewer here: you can look things up, and an Editor or Admin makes changes.",
    history: {
      title: "History",
      empty: "No changes yet.",
      older: "Show older changes",
      someone: "Someone",
      system: "Optymyse",
      via: "in {app}",
    },
  },
  customers: {
    title: "Customers",
    description: "Your organisation's companies, A to Z. Every Optymyse app reads them from here.",
    search: "Search customers",
    add: "New customer",
    empty: "No customers yet",
    emptyBody: "Add your first customer, and every Optymyse app your organisation uses will know them.",
    noMatches: "No customers match “{q}”.",
    columns: { name: "Name", domain: "Domain", updated: "Updated" },
    count: "{count} customers",
    page: {
      edit: "Edit",
      details: "Details",
      displayName: "Name",
      legalName: "Legal name",
      domain: "Domain",
      website: "Website",
      address: "Address",
      notes: "Notes",
      none: "None",
      contacts: "Contacts",
      noContacts: "No contacts at this customer yet.",
      addContact: "Add a contact",
      gone: "This customer isn't in your directory.",
      back: "Back to customers",
    },
    form: {
      newTitle: "New customer",
      editTitle: "Edit {name}",
      displayName: "Name",
      displayNameHint: "How everyone in your organisation knows them.",
      legalName: "Legal name",
      domain: "Domain",
      domainHint: "Their web address's host, such as acme.example.",
      website: "Website",
      address: "Address",
      line1: "Address line 1",
      line2: "Address line 2",
      city: "Town or city",
      region: "County, state or region",
      postcode: "Postcode",
      country: "Country",
      noCountry: "No country",
      findCountry: "Find a country",
      notes: "Notes",
      notesHint: "Anything your colleagues should know. Line breaks are kept.",
      create: "Create customer",
      save: "Save changes",
      cancel: "Cancel",
      required: "Give the customer a name.",
      nothingChanged: "Nothing has changed yet.",
      created: "Created {name}",
      saved: "Saved {name}",
      conflictTitle: "Someone else changed this customer.",
      conflict: "It was changed since you opened it. Its latest version is shown below: make your change again.",
    },
  },
  contacts: {
    title: "Contacts",
    description: "The people at your customers, A to Z.",
    search: "Search contacts",
    add: "New contact",
    empty: "No contacts yet",
    emptyBody: "Add the people you deal with at your customers.",
    noMatches: "No contacts match “{q}”.",
    columns: { name: "Name", email: "Email", phone: "Phone", company: "Customer", updated: "Updated" },
    count: "{count} contacts",
    kinds: { email: "Email", phone: "Phone", other: "Other" },
    primary: "Primary",
    page: {
      edit: "Edit",
      details: "Details",
      names: "Names",
      givenName: "Given name",
      familyName: "Family name",
      preferredName: "Preferred name",
      methods: "Ways to reach them",
      noMethods: "No email address or phone number yet.",
      companies: "Customers",
      noCompanies: "Not linked to a customer yet.",
      relationship: "Relationship",
      title: "Job title",
      department: "Department",
      gone: "This contact isn't in your directory.",
    },
    form: {
      newTitle: "New contact",
      editTitle: "Edit {name}",
      displayName: "Display name",
      displayNameHint: "Leave it empty to use their names.",
      givenName: "Given name",
      familyName: "Family name",
      preferredName: "Preferred name",
      methods: "Ways to reach them",
      methodsHint: "Each save renews these, so their order and primaries are what you see here.",
      kind: "Kind",
      value: "Email, number or address",
      label: "Label",
      labelHint: "Such as Work or Mobile; needed for Other.",
      primary: "Primary",
      addMethod: "Add a way to reach them",
      removeMethod: "Remove",
      companies: "Customers",
      company: "Customer",
      chooseCompany: "Choose a customer",
      findCompany: "Find a customer",
      relationship: "Relationship",
      relationshipHint: "Such as employee or contractor: employee if left empty.",
      title: "Job title",
      department: "Department",
      addCompany: "Link to a customer",
      removeCompany: "Remove",
      create: "Create contact",
      save: "Save changes",
      cancel: "Cancel",
      required: "Give the contact a name: a display name, or a given or family name.",
      labelRequired: "Give it a label, saying what it is.",
      nothingChanged: "Nothing has changed yet.",
      created: "Created {name}",
      saved: "Saved {name}",
      conflictTitle: "Someone else changed this contact.",
      conflict: "It was changed since you opened it. Its latest version is shown below: make your change again.",
    },
  },
} as const;

/** A string with its `{name}`s filled in. */
export function fill(text: string, values: Readonly<Record<string, string | number>>): string {
  return text.replace(/\{(\w+)\}/g, (whole, name: string) => (name in values ? String(values[name]) : whole));
}
